import React, { useEffect, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import {
    getDepartments, createDepartment, resetDepartment, resetNewlycreatedDepartmentId, deleteDepartment,
    openDepartment,
    updateDepartment, resetNewlycreatedCompanyId, updateCompany,
    deleteCompany,
    openDepartmentDashboard, getCompanies,
} from "../../store/actions/departmentActions";

import {
    getComplianceStandardsByCompany, deleteComplianceStandard
} from "../../store/actions/complianceActions";
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";

import moment from 'moment';
import LOADER from "../../assets/images/loader.svg";
import { useHistory } from 'react-router-dom';
import { LuPlus } from "react-icons/lu";
import { HiOutlineDotsVertical } from "react-icons/hi";
import CompanyOverlay from "../../components/Departments/CompanyOverlay";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import ComplianceOverlay from "../../components/Compliance/Overlay";


import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";

import Overlay from "../../components/Departments/Overlay";
//import DepartmentTable from "../../components/Departments/DepartmentTable";
import DepartmentCard from "../../components/Departments/DepartmentCard";

function Departments(props) {

    const {company_id, resetNewlycreatedCompanyIdFN, updateCompanyFN, deleteCompanyFN, deleteStandartFN, complianceStandards, companies, getComplianceStandardsByCompanyFN, getCompaniesFN, updateDepartmentFN, token, getDepartmentsFN, departments, department_id, resetDepartmentFN, createDepartmentFN, deleteDepartmentFN, openDepartmentFN, department_dashboard_data, newlycreatedDepartmentId, resetNewlycreatedDepartmentIdFN } = props;

    const { t } = useTranslation();
    const history = useHistory();

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [isDepartmentOpen, setIsDepartmentOpen] = useState(false);

    const [currentDepartment, setCurrentDepartment] = useState(null);

    const [catalog, setCatalog] = useState("departments"); // "departments" | "companies"

    const [editCompliance, setEditCompliance] = useState(null);

    const [companyMenuOpenId, setCompanyMenuOpenId] = useState(null);
    const [currentCompany, setCurrentCompany] = useState(null);
    const [isCompanyPopupOpen, setIsCompanyPopupOpen] = useState(false);

    // Compliance 3-dots menu state
    const [complianceMenuOpenId, setComplianceMenuOpenId] = useState(null);
    const [currentCompliance, setCurrentCompliance] = useState(null);
    const [isCompPopupOpen, setIsCompPopupOpen] = useState(false);

    const closeCreation = async (id, data) => {
        ////console.log("ID ", id, " DATA ", data)
        if (id)
            await updateDepartmentFN(id, data)
        getDepartmentsFN();
        resetDepartmentFN();
        resetNewlycreatedDepartmentIdFN();
        setIsPopupOpen(false);

    }


    useEffect(() => {
        if (newlycreatedDepartmentId) {
            ////////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
            ////////console.log("department", department);
            resetNewlycreatedDepartmentIdFN();
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newlycreatedDepartmentId]);

    useEffect(() => {
        getDepartmentsFN();
        getCompaniesFN();
        getComplianceStandardsByCompanyFN();
    }, []);

    useEffect(() => {
        //alert(department_id);
        if (department_id) {
            let department = departments && departments.find(department => department.department_id === department_id);

            //////////console.log(department_id, department);
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
    }, [department_id]);


    useEffect(() => {
        if (department_dashboard_data) {
            history.push({ pathname: "/risk_center", state: { departmentfromredirect: department_dashboard_data } });
        }
    }, [department_dashboard_data]);

    useEffect(() => {
        if (newlycreatedDepartmentId) {
            ////////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
            ////////console.log("department", department);
            resetNewlycreatedDepartmentIdFN();
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
    }, [newlycreatedDepartmentId]);

    const [qDept, setQDept] = useState("");
    const [view, setView] = useState("grid"); // "grid" | "table"

    const norm = (v) =>
        String(v ?? "")
            .normalize("NFD")
            .replace(/\p{Diacritic}/gu, "")
            .toLowerCase()
            .replace(/\s+/g, " ")
            .trim();

    const filteredDepartments = useMemo(() => {
        const q = norm(qDept);
        if (!q) return departments || [];
        return (departments || []).filter((d) => {
            const hay = [
                d?.name,
                d?.description,
                d?.head_name ?? [d?.head_first_name, d?.head_last_name].filter(Boolean).join(" "),
                `${d?.employee_count ?? d?.employees ?? ""}`,
            ]
                .map(norm)
                .join(" ");
            return hay.includes(q);
        });
    }, [departments, qDept]);

    const closeCreationCompnay = async (id, data) => {
        if (id)
            await updateCompanyFN(id, data)
        getCompaniesFN()
        resetNewlycreatedCompanyIdFN();
        setIsCompanyPopupOpen(false);
        ////console.log("Close company ", data, id)
    }


    const closeCompliance = async () => {
        setIsCompPopupOpen(false);
        setEditCompliance(null);


        await getComplianceStandardsByCompanyFN();
    };

    const safeCatalog = catalog || "departments";

    const unified = [
        ...(Array.isArray(departments) ? departments.map((x) => ({ ...x, __type: "department", _key: `department-${x.department_id || x.id}` })) : []),
        ...(Array.isArray(companies) ? companies.map((x) => ({ ...x, __type: "company", _key: `company-${x.company_id || x.id}` })) : []),
    ];

  const unifiedFiltered = unified.filter((x) => {
    const q = (qDept || "").toLowerCase().trim();

    const matchesCatalog =
      safeCatalog === "companies"
        ? x.__type === "company"
        : x.__type === "department";

    const name = (x.name || x.title || x.company_name || x.department_name || "").toLowerCase();
    const definition = (x.definition || x.description || "").toLowerCase();

    // NEW: company filter
    const matchesCompany =
      !company_id || x.company_id === company_id;


    return (
      matchesCatalog &&
      matchesCompany &&
      (!q || name.includes(q) || definition.includes(q))
    );
  });
  console.log(unifiedFiltered)

    const onEditItem = (x) => {
        if (x.__type === "company") {
            setCurrentCompany?.(x);
            setIsCompanyPopupOpen?.(true);
        } else {
            //console.log(x)
            //console.log("Current dep ", currentDepartment)
            setCurrentDepartment(x)
            setIsPopupOpen(true)
        }
    };

    const onDeleteItem = (x) => {
        if (x.__type === "company") {
            deleteCompanyFN?.(x.company_id || x.id);
        } else {
            deleteDepartmentFN?.(x.department_id || x.id);
        }
    };



  const onManageSubRiskCenter = (x) => {
    console.log(x)
    history.push("/manage_sub_risk_center/" + x.department_id)

  };

  return (
    <div className="incidents">
      <div className="ml-6 mr-6">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
          <div className="mt-0 grid grid-cols-1 md:grid-cols-[minmax(220px,1fr)_auto_auto] gap-3">
            <div className="relative w-full">
              <input
                value={qDept}
                onChange={(e) => setQDept(e.target.value)}
                placeholder={
                  safeCatalog === "companies"
                    ? t("adminManagement.departments.searchRiskCentersPlaceholder")
                    : t("adminManagement.departments.searchSubRiskCentersPlaceholder")
                }
                className="
      w-full h-11 pl-11 pr-4
      rounded-xl
      bg-white
      border border-transparent
      text-[13px] text-[#2C2C2C]
      placeholder:text-[#9CA3AF]
      shadow-sm
      ring-1 ring-[#E5E7EB]
      transition-all duration-150
      focus:outline-none
      focus:ring-2 focus:ring-[#3B82F6]/20
      focus:border-transparent
    "
              />

              <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg
                  className="w-4 h-4 text-[#9CA3AF]"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle cx="11" cy="11" r="7" strokeWidth="1.8" />
                  <path d="M20 20l-3.5-3.5" strokeWidth="1.8" />
                </svg>
              </div>
            </div>

            {/* <div className="hidden md:inline-flex items-center rounded-lg border border-gray-200 overflow-hidden h-10">
               <button
                 type="button"
                 onClick={() => setCatalog("departments")}
              className={`px-3 text-sm ${
                safeCatalog === "departments"
                  ? "bg-[#0B0B0F] text-white"
                  : "bg-white text-gray-600"
              }`}
            >
              Sub Risk Centers
            </button>
            <button
              type="button"
              onClick={() => setCatalog("companies")}
              className={`px-3 text-sm border-l border-gray-200 ${
                safeCatalog === "companies"
                  ? "bg-[#0B0B0F] text-white"
                  : "bg-white text-gray-600"
              }`}
            >
              Risk Centers
            </button>
          </div> */}

          <div className="hidden md:inline-flex items-center rounded-lg border border-gray-200 overflow-hidden h-10">
            <button
              type="button"
              onClick={() => setView("grid")}
              className={`px-3 text-sm ${
                view === "grid"
                  ? "bg-gray-100 text-gray-900"
                  : "bg-white text-gray-600"
              }`}
            >
              {t("adminManagement.view.grid")}
            </button>
            <button
              type="button"
              onClick={() => setView("table")}
              className={`px-3 text-sm border-l border-gray-200 ${
                view === "table"
                  ? "bg-[#0B0B0F] text-white"
                  : "bg-white text-gray-600"
              }`}
            >
              {t("adminManagement.view.table")}
            </button>
          </div>
        </div>

        <div className="mt-4">
          {view === "table" ? (
            <div className="rounded-2xl border border-gray-200 overflow-x-auto overflow-y-visible">
              <table className="w-full text-sm text-gray-800">
                <thead className="bg-white">
                  <tr className="border-b border-gray-200">
                    <th className="text-left font-medium text-gray-700 px-4 py-3">
                      {t("riskCenterPortal.departmentsList.columns.name")}
                    </th>
                    <th className="text-left font-medium text-gray-700 px-4 py-3">
                      {t("riskCenterPortal.departmentsList.columns.type")}
                    </th>
                    <th className="text-left font-medium text-gray-700 px-4 py-3">
                      {t("riskCenterPortal.departmentsList.columns.definition")}
                    </th>
                    <th className="text-left font-medium text-gray-700 px-4 py-3 w-[150px]">
                      {t("riskCenterPortal.departmentsList.columns.actions")}
                    </th>
                  </tr>
                </thead>

                <tbody className="bg-white">
                  {unifiedFiltered.map((x) => {
                    const typeLabel =
                      x.__type === "company"
                        ? t("riskCenterPortal.departmentsList.rowTypes.company")
                        : x.__type === "compliance"
                        ? t("riskCenterPortal.departmentsList.rowTypes.compliance")
                        : t("riskCenterPortal.departmentsList.rowTypes.department");

                    return (
                      <tr
                        key={x._key}
                        className="hover:bg-gray-50 transition-colors border-t border-gray-100"
                      >
                        <td className="px-4 py-3 text-gray-900 font-medium">
                          {x?.name ?? "-"}
                        </td>

                        <td className="px-4 py-3">
                          <span className="inline-flex items-center gap-2">
                            <span
                              className="w-2 h-2 rounded-full"
                              style={{ backgroundColor: x.color || "#111827" }}
                            />
                            <span className="text-gray-600">{typeLabel}</span>
                          </span>
                        </td>

                        <td className="px-4 py-3 text-gray-700">
                          <span className="line-clamp-2">
                            {x?.definition ?? "-"}
                          </span>
                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                onEditItem(x);
                              }}
                              className="p-1.5 rounded-md hover:bg-gray-100"
                              title={t("adminManagement.departments.menu.edit")}
                            >
                              <svg
                                className="w-5 h-5 text-gray-700"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path strokeWidth="1.8" d="M12 20h9" />
                                <path
                                  strokeWidth="1.8"
                                  d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
                                />
                              </svg>
                            </button>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                onDeleteItem(x);
                              }}
                              className="p-1.5 rounded-md hover:bg-red-50"
                              title={t("adminManagement.departments.menu.delete")}
                            >
                              <svg
                                className="w-5 h-5 text-red-500"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path strokeWidth="1.8" d="M3 6h18" />
                                <path
                                  strokeWidth="1.8"
                                  d="M8 6v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6"
                                />
                                <path strokeWidth="1.8" d="M10 11v6M14 11v6" />
                                <path
                                  strokeWidth="1.8"
                                  d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}

                  {unifiedFiltered.length === 0 && (
                    <tr>
                      <td
                        colSpan={4}
                        className="px-4 py-8 text-center text-gray-500"
                      >
                        {t("riskCenterPortal.departmentsList.noResults")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 md:gap-10">
              {unifiedFiltered.map((x) => (
                <DepartmentCard
                  key={x._key}
                  department={x}
                  onEdit={() => onEditItem(x)}
                  onDelete={() => onDeleteItem(x)}
                  onManageSubRiskCenter={()=> onManageSubRiskCenter(x)}
                />
              ))}
            </div>
          )}
        </div>

        <div className="text-sm text-gray-500 mt-3 flex items-center justify-between">
          <span>
            {safeCatalog === "companies"
              ? t("riskCenterPortal.departmentsList.showingCompanies", {
                  shown: unifiedFiltered.length,
                  total: unified.length,
                })
              : t("riskCenterPortal.departmentsList.showingItems", {
                  shown: unifiedFiltered.length,
                  total: unified.length,
                })}
          </span>
        </div>

           <Popup
             open={isPopupOpen}
             onClose={closeCreation}
             contentStyle={{
               overflowY: "auto",
               overflowX: "hidden",
               maxHeight: "80vh",
               width: "830px",
               marginTop: "14vh",
             }}
           >
             <Overlay close={closeCreation} department={currentDepartment} edit={true} />
           </Popup>
         </div>
    </div>
  </div>
);









}

const mapStateToProps = (state) => {
    //console.log("department_dashboard_data ",state.compliance.complianceStandards,)
    return {

        token: state.auth.token,
        departments: state.department.departments,
        department_id: state.department.department_id,
        department_dashboard_data: state.department.department_dashboard_data,
        newlycreatedDepartmentId: state.department.newlycreatedDepartmentId,
        companies: state.department.companies,
        complianceStandards: state.compliance.complianceStandards,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getDepartmentsFN: () => dispatch(getDepartments()),
        resetDepartmentFN: () => dispatch(resetDepartment()),
        createDepartmentFN: () => dispatch(createDepartment()),
        resetNewlycreatedDepartmentIdFN: () => dispatch(resetNewlycreatedDepartmentId()),
        deleteDepartmentFN: (id) => dispatch(deleteDepartment(id)),
        openDepartmentFN: (id) => dispatch(openDepartment(id)),
        updateDepartmentFN: (department_id, data) => dispatch(updateDepartment(department_id, data)),
        getCompaniesFN: () => dispatch(getCompanies()),
        getComplianceStandardsByCompanyFN: () => dispatch(getComplianceStandardsByCompany()),
        deleteStandartFN: (compliance_id) => dispatch(deleteComplianceStandard(compliance_id)),
        deleteCompanyFN: (id) => dispatch(deleteCompany(id)),
        resetNewlycreatedCompanyIdFN: () => dispatch(resetNewlycreatedCompanyId()),
        updateCompanyFN: (company_id, data) => dispatch(updateCompany(company_id, data)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Departments);

